import { render, staticRenderFns } from "./ToyRegister.vue?vue&type=template&id=04499f3c"
import script from "./ToyRegister.vue?vue&type=script&lang=js"
export * from "./ToyRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports